// Minimap strings (English) — merged in ./messages.ts; Spanish in ./minimapEs.ts.
// Biome names reuse the shared `biome.*` keys.

export const minimapEn = {
  'minimap.title': 'Minimap',
  'minimap.aria':
    'Minimap. Arrow keys move the focus, Enter centres the camera there, C jumps to the next own city, plus and minus zoom, zero fits the whole board.',
  'minimap.summary':
    'Minimap: {cities} cities visible, zoom {zoom}x, camera at {camera}, focus {q},{r}: {what}',
  'minimap.cameraBox': 'Camera view box',
  'minimap.zoomIn': 'Zoom in',
  'minimap.zoomOut': 'Zoom out',
  'minimap.fit': 'Fit board',
  'minimap.legend': 'Legend',
  'minimap.legendTitle': 'Minimap legend',
  'minimap.unexplored': 'Unexplored',
  'minimap.coords': '({q}, {r})',
  'minimap.owner': 'Owner: {owner}',
  'minimap.unclaimed': 'Unclaimed',
  'minimap.you': 'You',
  'minimap.city': 'City',
  'minimap.cityNamed': 'City {name}',
  'minimap.cityTier': 'Tier {tier}',
  'minimap.capital': 'Capital',
  'minimap.village': 'Neutral village',
  'minimap.unitsOwn': 'Your units: {count}',
  'minimap.unitsOther': 'Units: {count}',
  'minimap.explored': 'Explored',
  'minimap.fog': 'Fog',
  'minimap.unit': 'Unit',
  'minimap.border': 'Territory border',
  'minimap.marker': 'Champion',
  'minimap.layers': 'Layers',
  'minimap.layerTerritory': 'Territory',
  'minimap.layerFog': 'Fog of war',
  'minimap.layerUnits': 'Cities & units',
  'minimap.layerRivers': 'Rivers',
  'minimap.layerRelief': 'Relief',
  'minimap.size': 'Size',
  'minimap.sizeS': 'Small',
  'minimap.sizeM': 'Medium',
  'minimap.sizeL': 'Large',
  'minimap.collapse': 'Collapse minimap',
  'minimap.expand': 'Expand minimap',
  'minimap.biome.river': 'River',
} as const;
